import { cardStatusConstants } from "../constants/action.constants";
import { cardStatusService } from "../services/cardStatus.service";
import { alertActions } from "../../../Alert/actions/alert.actions";
import { message } from "../../../../_constants";

export const cardStatusActions = {
  getCardStatus
};

function getCardStatus(params) {
  return async dispatch => {
    dispatch(request(params));
    try {
      const response = await cardStatusService.getCardStatus(params);
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        alertActions.error(
          error ? error.message : message.GENERIC_ERROR,
          message.LOAD_CARD_STATUS
        )
      );
    }
  };

  function request(params) {
    return { type: cardStatusConstants.GET_CARDSTATUS_REQUEST, params };
  }
  function success(response) {
    return { type: cardStatusConstants.GET_CARDSTATUS_SUCCESS, response };
  }
  function failure(error) {
    return { type: cardStatusConstants.GET_CARDSTATUS_FAILURE, error };
  }
}
